import React from 'react';
import { useAST } from '@saucerjs/core';
import { RenderWrapper } from './components/RenderWrapper';
import { useRenderChildren } from './hooks/useRenderChildren';
import { useViewportShortcuts } from './hooks/useViewportShortcuts';
/**
 * Main View of User Operation to Drag and Drop
 */
export var Viewport = React.memo(function (props) {
    var el = useRenderChildren({ hasWrapper: true });
    var root = useAST();
    var handleViewportKeyUp = useViewportShortcuts().handleViewportKeyUp;
    return (React.createElement("div", { className: "saucer-editor-viewport", style: props.style, tabIndex: 1, onKeyUp: handleViewportKeyUp },
        React.createElement(RenderWrapper, { path: "", tea: root }, el)));
});
Viewport.displayName = 'Viewport';
